export default {
  SET_RECHARGE_OPERATORS (state, payload) {
    state.rechargeOperators = payload;
  },
  SET_RECHARGE_AMOUNTS (state, payload) {
    state.rechargeAmounts = payload;
  },
};
